import { pickBy } from 'lodash'
import { captureSentryException } from '@edulastic/common'
import { segmentApi } from '@edulastic/api'
import { hasActiveSearchCriteria } from '../dataUtils'
import { aggregateCountsByBankName } from '../utils/sourceBankResolver'

export const LIBRARY_SEARCH_SEGMENT = {
  ZERO_RESULTS_FOUND: 'search_zero_results_found',
  DENSITY_VIEWED: 'search_result_item_density_viewed',
  TEST_MODAL_OPENED: 'search_result_test_modal_opened',
}

const LIBRARY_TYPE_LABELS = {
  test: 'Test Library',
  item: 'Item Library',
}

const SEGMENT_CONFIG = { attachUserData: true }

const hasFilterValue = (value) => {
  if (Array.isArray(value)) return value.length > 0
  return value !== '' && value != null
}

export const trackSearchZeroResults = ({
  filter = {},
  libraryType,
  userId,
}) => {
  if (!hasActiveSearchCriteria(filter)) return

  const { searchString } = filter
  const search_term = Array.isArray(searchString)
    ? searchString.join(' ')
    : searchString || ''

  segmentApi.genericEventTrack(LIBRARY_SEARCH_SEGMENT.ZERO_RESULTS_FOUND, {
    search_term,
    filters_applied: pickBy(filter, hasFilterValue),
    library_type: LIBRARY_TYPE_LABELS[libraryType] || libraryType,
    user_id: userId ? `${userId}` : '',
  })
}

export const trackSearchResultDensity = ({
  rows,
  page,
  flow,
  libraryType,
  scoresById = {},
}) => {
  try {
    if (!rows?.length || !page) return

    const countsByBankName = aggregateCountsByBankName(rows)

    segmentApi.genericEventTrack(
      LIBRARY_SEARCH_SEGMENT.DENSITY_VIEWED,
      {
        countsByBankName,
        scoresById,
        page,
        flow,
        libraryType,
      },
      SEGMENT_CONFIG
    )
  } catch (error) {
    captureSentryException(error, {
      errorMessage:
        'Library search analytics: Error tracking search_result_item_density_viewed',
      flow,
      libraryType,
      page,
      rowCount: rows?.length,
    })
  }
}

export const trackTestModalOpened = ({ test, page }) => {
  try {
    if (!test?._id) return

    const countsByBankName = aggregateCountsByBankName([test])

    segmentApi.genericEventTrack(
      LIBRARY_SEARCH_SEGMENT.TEST_MODAL_OPENED,
      {
        testId: test._id,
        page,
        countsByBankName,
        libraryType: 'test',
      },
      SEGMENT_CONFIG
    )
  } catch (error) {
    captureSentryException(error, {
      errorMessage:
        'Library search analytics: Error tracking search_result_test_modal_opened',
      testId: test?._id,
      page,
    })
  }
}
